<template>
  <div style="background-color: #f2f2f2;height: 100%;">
    <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
      摄像头
    </div>
    <div style="padding: 20px;">

      <div>

        <el-row>
          <el-button type="primary" :disabled="disabledAdd" @click.native="toggleModalAdd">添加</el-button>
          <el-button type="success" :disabled='disabledEdit' @click.native="handleEdit">编辑</el-button>
          <el-button type="danger" :disabled='disabledDel' @click="delCamera" >删除</el-button>
          <div style="float:right">
            <el-input placeholder="请输入名称" v-model="name" maxlength="11" clearable
                      style="width:200px;margin-right:10px"></el-input>

            <el-cascader
                v-model="roomCodeList"
                placeholder="请选择房间"
                :options="options"
                filterable
                clearable
                @change="handleChange" style="margin:0 10px;float:left">
            </el-cascader>

            <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
          </div>
        </el-row>
        <div style="clear: both;"></div>
      </div>

      <div style="height: 10px;"></div>

      <div>
        <template>

          <el-table :data="tableData" v-loading="loading" highlight-current-row @row-click='rowClick' :height="th" border style="width: 100%;">

            <el-table-column prop="name" label="设备名称"></el-table-column>

            <el-table-column prop="buildingName" label="楼宇名称"></el-table-column>

            <el-table-column prop="roomName" label="房间号"></el-table-column>

            <el-table-column prop="gatewayId" label="设备序列号"></el-table-column>

            <el-table-column  :formatter="getTime" label="添加时间"></el-table-column>


            <el-table-column
                prop="Status"
                :formatter="statusTitle"
                label="状态">
            </el-table-column>

            <el-table-column fixed="right" label="操作" width="250">
              <template slot-scope="scope">
                <!-- <el-button type="primary" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
                <el-button type="danger" size="small" @click="openDetails(scope.$index, scope.row)">子设备详情</el-button>
              </template>
            </el-table-column>

          </el-table>

          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>


        </template>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-bind:options="options" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-bind:options="options" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>
    <Details ref="myDetails" v-show="showModalDetails" v-on:closeDetails="closeDetails" v-on:getList="getList"></Details>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Edit from "./Edit";
import Add from "./Add";
import Details from "./Details";
import {getToken,getStaffCode,getMenuButton} from "@/utils/auth";

export default {
  name: "Page",
  data(){
    return{
      showModalDetails:false,
      institutionCode:'',
      disabledAdd:true,
      disabledDel:true,
      disabledEdit:true,
      menuButtonList:null,
      loading:false,
      name:'',
      showModalAdd:false,
      showModalEdit:false,
      searchDishes:'',
      tableData:null,
      row:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      th:0,
      roomCodeList:[],
      roomCode:'',
      options:[]
    }
  },
  components:{
    Add,Edit,Details
  },
  created(){
    this.institutionCode = JSON.parse(getToken()).institutionCode;
    this.getList();
    this.init();
    this.getMenu();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{
    getMenu(){
        let list = JSON.parse(window.localStorage.getItem("listMenuDTO"));
        var menu = getMenuButton(list,this.$route.path);
        this.menuButtonList = JSON.stringify(menu);
        if(menu!=null&&menu.length>0){
            for(let i=0;i<menu.length;i++){
                if(menu[i].buttonName=="添加"){
                    this.disabledAdd = false;
                }
            }
        }
    },
    handleEdit() {
      this.$refs.myEdit.init(this.row);
      this.showModalEdit = !this.showModalEdit;
    },
    openDetails(index,row){
      this.$refs.myDetails.init(row);
      this.showModalDetails = !this.showModalDetails;
    },
    closeDetails:function(){
      this.showModalDetails = !this.showModalDetails;
    },
    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closePreview:function (){
      this.showModalPreview =!this.showModalPreview;
    },
    closePlayback:function(){
      this.showModalPlayback=!this.showModalPlayback;
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getTime(row){
      var  a =row.bindTime.substr(0,10);
      var  b =row.bindTime.substr(11,8);

      return a+"\n"+b;
    },
    statusTitle(row){
      if(row.status === 0){
        return "默认";
      }
      if(row.status === 1){
        return "正常";
      }
      if(row.status === 2){
        return "禁用";
      }
      return "其它";
    },
    handleClear(){
        this.roomCode='';
        console.log(this.roomCode)
    },
    handleChange(value) {
        if(value.length==0){
            this.roomCode='';
        }else{
            this.roomCode=value[1];
        }
        console.log(this.roomCode);
    },
    getList(){
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"YJGateway/Page",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          organizationCode:this.institutionCode,
          name:this.name,
          roomCode:this.roomCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {
        this.disabledEdit = true;
        this.disabledDel =true;
        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    init:function(){
        this.$axios({
            method: 'post',
            url: this.$institutionUrl+"Room/ListRoom",
            data: {
                timeStr: timeStr,
                sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                staffCode: getStaffCode(),
            }
        }).then(
            (response) => {
                if (response.data.error == 0) {
                    var datas= response.data.data;
                    var JSONData=JSON.stringify(datas);
                    JSONData=JSONData.replace(/listRoomDTO/g,'children');
                    JSONData=JSONData.replace(/name/g,'label');
                    JSONData=JSONData.replace(/roomCode/g,'value');
                    JSONData=JSONData.replace(/number/g,'label');
                    this.options = JSON.parse(JSONData);
                }else if(response.data.error == 1){
                    this.$message({type: 'info', message: response.data.message});
                }
            }
        )
    },
    rowClick(row){
      this.row = row;
      if(this.menuButtonList.indexOf("编辑")!=-1){
          this.disabledEdit =false;
      }
      if(this.menuButtonList.indexOf("删除")!=-1){
          this.disabledDel =false;
      }
    },
    delCamera(){
      this.$confirm('此操作将删除该设备, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.del();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    del(){
      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"YJGateway/Unbundling",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          gatewayId:this.row.gatewayId
        }
      }).then( (response)=> {
        this.disabledDel =true;
        if(response.data.error == 0){
          this.getList();
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
  }
}
</script>

<style lang="scss" scoped>
    /deep/ .el-table__body tr.current-row>td {
        background-color: #409EFF;
        color:#fff;
    }

</style>
